import globals from "@/util/global-whitelist.mjs";

// returns true if the current URL has a query string with the given name
export default function hasQueryString(name: string) {
  if (!globals.location?.href) return false;
  return (
    typeof new URL(globals.location.href).searchParams.get(name) === "string"
  );
}

const initialUrl = globals.location?.href && new URL(globals.location.href);
// returns true if the initial URL has a query string with the given name
export function hasInitialQueryString(name: string) {
  if (!initialUrl) return false;
  return typeof initialUrl?.searchParams.get(name) === "string";
}
